import { Ajax, useAction } from 'utils';

export const useFetchEventDetailData = () =>
  useAction(({ orgId, notificationId, event_id }) =>
    Ajax.get(
      `/nixle/eventSubscription/getNotificationDetail/${orgId}/${notificationId}${event_id ? `?event_id=${event_id}` : ''}`,
    ));
